import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Me } from "@workcore/schemas";
import { get } from "../api";
import { EmptyState, ErrorBox, PageHeader } from "../ui";

/**
 * The workspace's front door. It reads /me first, because that first request accepts an open
 * invitation (design 16.2), then goes straight to Projects. A member whose roles include no
 * configuration is told so instead.
 */
export function MyWorkspacePage() {
  const { slug = "" } = useParams();
  const queries = useQueryClient();
  const me = useQuery({ queryKey: ["ws-me", slug], queryFn: async () => Me.parse(await get(`/v1/ws/${slug}/me`)) });
  useEffect(() => {
    if (me.isSuccess) void queries.invalidateQueries({ queryKey: ["platform-me"] });
  }, [me.isSuccess, queries]);
  const m = me.data;
  if (me.error) return <ErrorBox error={me.error} />;
  if (!m) return <p className="muted">Loading…</p>;
  const configures = m.isSystemAdmin || m.roles.some((r) => r.role === "workflow_admin" || r.role === "project_admin");
  if (configures) return <Navigate to={`/w/${slug}/projects`} replace />;
  return (
    <>
      <PageHeader title={m.workspace.name} />
      <EmptyState
        title="Nothing to configure here"
        body="Your roles in this workspace don't include configuration. Your work happens through the API, the MCP server (Claude) or a work UI; ask a system admin if you need more."
      />
    </>
  );
}
